import { call, put } from 'redux-saga/effects';

import generateQuery from 'utils/generateQuery';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import {
  CATALOG_ORDERS,
  NOTIFICATION,
} from '../actionTypes';

const fetchCatalogOrders = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  if (payload.filterParams && !payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_CATALOAG_ORDER}?${payload.filterParams}`);
  }
  if (payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_CATALOAG_ORDER}${query}${sorting}&${payload.filterParams}`);
  }
  if (!payload.filterParams && payload.sortParams) {
    return axiosAuthInstance.get(`${API_END_POINTS.GET_CATALOAG_ORDER}${query}${sorting}`);
  }
  return axiosAuthInstance.get(`${API_END_POINTS.GET_CATALOAG_ORDER}${query}${sorting}`);
};

export function* getCatalogOrders(action) {
  try {
    const { data: { entity } } = yield call(fetchCatalogOrders, action.payload);
    yield put({ type: CATALOG_ORDERS.SUCCESS, payload: entity });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
    yield put({ type: CATALOG_ORDERS.FAILED, payload: e.response.data });
  }
}
